module.exports = __webpack_public_path__ + "static/media/energetic.155b1790.png";